export default "__VITE_ASSET__51850283__"